import { render, staticRenderFns } from "./MyDossiersView.vue?vue&type=template&id=38a1385a&scoped=true"
import script from "./MyDossiersView.vue?vue&type=script&lang=ts"
export * from "./MyDossiersView.vue?vue&type=script&lang=ts"
import style0 from "./MyDossiersView.vue?vue&type=style&index=0&id=38a1385a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a1385a",
  null
  
)

export default component.exports